export const meanUserId = "u-mean-user";
export const loadTestingUserId = "u-load-test";

// Demo rounds have no dedicated DB flag — they are identified by the name
// suffix appended by buildRoundName in server/lib/demoRoundCreation.ts.
export const demoRoundNameSuffix = " Demo Round";

export function isDemoRoundName(roundName: string): boolean {
  return roundName.endsWith(demoRoundNameSuffix);
}

type ProposalFormInfo = {
  googleFormId: string;
  spreadsheetId: string;
  spreadsheetRange: string;
};

export const proposalFormConstants: { [name: string]: ProposalFormInfo } = {
  "SFF Rolling Application (real)": {
    googleFormId: "1l_dpYL2cHuseIRbPGRDHaczH4-9avMNnKVbB3iqhWTw",
    spreadsheetId: "1cVoqqyXYDmAYorQ7SAfraEOr5FDPXMcTD2BYxP5Js5Y",
    spreadsheetRange: "Form Responses 1!A2:EC", // All rows but the first, all columns
  },
  "SFF Rolling Application (testing form and sheet)": {
    googleFormId: "12CAfbtI36s2aEonlxpVenOEEFBLITDzxKtosDEHp21Y",
    spreadsheetId: "1y17kY9UAhJlFwJxKP32fRb2gqNcfxlbT_jwxEfkRyhE",
    spreadsheetRange: "Form Responses 1!A2:EC", // All rows but the first, all columns
  },
  "SFF Rolling Application (real form + testing spreadsheet)": {
    googleFormId: "1l_dpYL2cHuseIRbPGRDHaczH4-9avMNnKVbB3iqhWTw",
    spreadsheetId: "1y17kY9UAhJlFwJxKP32fRb2gqNcfxlbT_jwxEfkRyhE",
    spreadsheetRange: "Form Responses 1!A2:EC", // All rows but the first, all columns
  },
};

export const speculationGrantsSpreadsheet = {
  id: "1-dWGMIdrP7H_qFs7E5JajxWEwnyquG_oRCkCNZdDoco",
  requestsRange: "Grant_Requests!A2:AV", // All columns
  grantsRange: "Grants_And_Settlements!A2:AO", // Through "Key grant info" (AM before the Spec Grant trial column inserts)
};

export const HOLD_AMOUNT = 1e12;

// Fraction of a video that must be played for it to count as "watched" — at
// that point it's auto-removed from the iPhone playlist, and the server latches
// the progress row's sticky `completedAt` (see `applyProgressUpdate`).
//
// ONE threshold on purpose: the queue's "watched" pill, the playlist's
// auto-removal and the To Do rail's completed step must agree, or a funder sees
// a video the queue calls finished sitting unticked on the rail.
export const mobileWatchedThreshold = 0.95;
